import { useIntl } from 'gatsby-plugin-intl'
import React from 'react'
import Helmet from 'react-helmet'
import { ECOMMERCE_MESSAGES } from '../../intl/messages'
import { NavigationContext } from '../../providers/navPage'
import NavbarDefault from '../../components/Navbar'
import {BottomNavbar} from '../../components/Navbar/BottomNavbar'
import { Box, Heading, SimpleGrid } from '@chakra-ui/react'
import { ProductCategoriesDropDown } from '../../components/Dropdowns/ProductCategories'
import { LandingSwiper } from '../../components/Swipers/LandingProductSwiper'
import { CollectionType } from '../../types/collections'
import { ProductItem } from '../../components/Cards/Order/Product'
import { HowtoShopCheaperwithBriddgy } from '../../components/Layout/HowtoShopCheaperwithBriddgy'
import { FAQ } from '../../components/Layout/FAQ'
import Footer from '../../components/Footer'
import { HorizontalPaymentInformation } from '../../components/Layout/HorizontalPaymentInformation'


const ProductCategory = ({pageContext:{category}}:{pageContext:{category:CollectionType}})=>{
    const intl = useIntl()
    
    

    return(
        <>
        <Helmet title={intl.formatMessage(ECOMMERCE_MESSAGES.category_title,{category:category.title})} defer={false}>
            <meta
          name="description"
          content={intl.formatMessage(ECOMMERCE_MESSAGES.category_description,{category:category.title})}
        />
      </Helmet>
      <NavigationContext.Provider value={{ page: "shop" }}>
        <NavbarDefault sx={{">div":{maxW:"container.xxxl"}}}/>
        <BottomNavbar />
    </NavigationContext.Provider>
        
        <ProductCategoriesDropDown selectedCateogry={category.title}/>
        
        <Box  py="80px" w='100%'  as='header' >
            <Box maxW='container.xl' mx='auto'>
                <LandingSwiper products={category.products}/>
            </Box>
        </Box>
        <HorizontalPaymentInformation mb={0}/>
        <Box mb={[20, 20, "150px"]}  py={[20, 20, "150px"]} bg='outline.light' as='section'>
            <Heading mb={4} as='h2' fontSize="hb3" fontWeight="700" textAlign="center"  >
                    {category.title}
            </Heading>
        <SimpleGrid px={[2,3,5]} my="120px" columns={[2,2,3]}  spacing={[3,5,8]} maxW='container.xl' mx='auto'>
            {
            category.products.map((item,index)=>(
                <ProductItem product={item}/>
            ))
            }
        </SimpleGrid>
        </Box>
        <HowtoShopCheaperwithBriddgy/>
        <FAQ/>
        <Footer/>
        </>
    )
}


export default ProductCategory